export const GET_GRADES = 'GET_GRADES';
export const GET_GRADES_SUCCESS = 'GET_GRADES_SUCCESS';
export const GET_GRADES_ERROR = 'GET_GRADES_ERROR';

export const ADD_NEW_GRADE = 'ADD_NEW_GRADE';
